// Components
import DirectoryBreadCrumb from "view/components/Breadcrumbs/DirectoryBreadCrumb";
import { PageHeading, AddReportBtn, OptionsModal } from "./components";
// Store Utils
import { useNavigate, useParams } from "react-router-dom";
import Restricted from "view/components/Restricted";
import usePermissions from "hooks/usePermissions";
import useRoles from "hooks/roles";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import apiLibrary from "services/api";

const generateDynamicBreadcrumbLinks = (programId: any, name: any) => {
  switch (true) {
    case Boolean(programId):
      return [
        { path: `/programs/list`, label: `Programs` },
        {
          path: `/programs/${programId}/profile`,
          label: name,
        },
        {
          path: `/programs/${programId}/reports`,
          label: `Reports`,
        },
      ];
    default:
      return [{ path: `/reports/list`, label: `Reports` }];
  }
};

export const Header = () => {
  const navigate = useNavigate();
  const { reports } = usePermissions();
  const { isExternalDataEndReviewer } = useRoles();
  const [IsShowModal, setIsShowModal] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);
  const { programId } = useParams<{
    programId: string;
  }>();

  const [breadcrumbData, setBreadcrumbData] = useState({
    name: "",
    id: "",
    showAddButton: false,
  });

  const handleAddReport = () => {
    setIsShowModal((prev) => !prev);
  };
  const handleClickToCreateReport = (type: string | null) => {
    navigate(`/reports/add?type=${type}`);
  };
  const dynamicCommunityLinks = generateDynamicBreadcrumbLinks(
    programId ?? "",
    breadcrumbData?.name ?? ""
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsShowModal(false); // Close the modal if click is outside
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchData = async (
      id: string,
      getDetailsFn: (id: string) => Promise<any>
    ) => {
      try {
        const data = await getDetailsFn(id);
        setBreadcrumbData({
          ...data,
          showAddButton: data.status !== "completed",
        });
      } catch (error: any) {
        console.log(error);
      }
    };

    if (programId) {
      fetchData(programId, getProgramDetails);
    }
  }, [programId]);
  async function getProgramDetails(programId: string) {
    try {
      const { data } = await apiLibrary.Programs.getProgramProfile(
        programId ? programId : ""
      );
      return data;
    } catch (error: any) {
      throw error;
    }
  }

  return (
    <div className="flex items-start self-stretch justify-start flex-grow-0 flex-shrink-0">
      <div className="flex items-start self-stretch justify-start flex-grow">
        <div className="flex flex-col items-start justify-start flex-grow gap-2">
          <DirectoryBreadCrumb links={dynamicCommunityLinks} />
          <div className="relative flex items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-2">
            <PageHeading programName={breadcrumbData?.name} />
            {!programId &&
              !isExternalDataEndReviewer() &&
              (reports.canCreateReports || reports.canCreateBasicReports) && (
                <AddReportBtn
                  buttonRef={buttonRef}
                  handleAddReport={handleAddReport}
                />
              )}
            <OptionsModal
              isOpen={IsShowModal}
              handleClickToCreateReport={handleClickToCreateReport}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
